module.exports = __webpack_public_path__ + "img/json-expand-icon.8fe05bc5.svg";